export default __webpack_public_path__ + "static/screeny-130-gpz-i-5-f06555184f05000b48bd282a5501c51d.jpg";